import { notifications } from "@mantine/notifications"
import { useMutation, UseMutationOptions } from "@tanstack/react-query"
import { AxiosError } from "axios"
import { useTranslation } from "react-i18next"

import { httpClient } from "~/backend/axios.ts"
import { queryClient } from "~/backend/queryClient"
import { findContactrMappingQueryKey } from "~/gen/api/hooks"

export const useDeleteContactMutation = (
  contactId: string,
  options?: UseMutationOptions<void, unknown>
) => {
  const { t } = useTranslation("suppliers")
  return useMutation({
    ...options,
    mutationFn: async () => {
      await httpClient.delete(`/v1/contacts/delete-contact/${contactId}`, {
        data: {
          contactId,
        },
      })
    },
    onSuccess: async (data, variables, onMutateResult, context) => {
      options?.onSuccess?.(data, variables, onMutateResult, context)
      await queryClient.invalidateQueries({
        queryKey: findContactrMappingQueryKey({ searchSupplier: "" }),
      })
      await queryClient.invalidateQueries({
        queryKey: ["listContacts"],
      })
      notifications.show({
        title: t("repository.delete.success.title"),
        message: t("repository.delete.success.message"),
        color: "teal",
      })
    },
    onError: (error, variables, onMutateResult, context) => {
      if (error instanceof AxiosError) {
        notifications.show({
          title: t("repository.delete.error.title"),
          message: t("repository.delete.error.message", {
            error: error.response?.data,
          }),
          color: "red",
        })
      }
      options?.onError?.(error, variables, onMutateResult, context)
    },
  })
}
